import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import {
  AddPromotionalBannerPayload,
  DeletePromotionalBannerPayload,
  PromotionalBanner,
  UpdatePromotionalBannerPayload,
  UpdatePromotionalBannerStatusPayload,
} from './promotionalBanner.types';

const addPromotionalBanner = (client: AxiosInstance) => async (payload: AddPromotionalBannerPayload) => {
  return (await client.post<{ message: string; data: PromotionalBanner }>(API_ROUTES.ADD_PROMOTIONAL_BANNER, payload))
    .data;
};

const updatePromotionalBanner = (client: AxiosInstance) => async (payload: UpdatePromotionalBannerPayload) => {
  return (
    await client.post<{ message: string; data: PromotionalBanner }>(API_ROUTES.UPDATE_PROMOTIONAL_BANNER, payload)
  ).data;
};

const updatePromotionalBannerStatus =
  (client: AxiosInstance) => async (payload: UpdatePromotionalBannerStatusPayload) => {
    return (
      await client.post<{ message: string; data: PromotionalBanner }>(
        API_ROUTES.UPDATE_PROMOTIONAL_BANNER_STATUS,
        payload,
      )
    ).data;
  };

const deletePromotionalBanner = (client: AxiosInstance) => async (payload: DeletePromotionalBannerPayload) => {
  return (
    await client.delete<{ message: string; data: PromotionalBanner }>(API_ROUTES.DELETE_PROMOTIONAL_BANNER, {
      data: payload,
    })
  ).data;
};

export const promotionalBannerMutations = {
  addPromotionalBanner,
  updatePromotionalBanner,
  updatePromotionalBannerStatus,
  deletePromotionalBanner,
};
